import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Start extends Component {
  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          The videos below explain each of our service levels in detail. However, only our Basic Service will be available at the start of the Beta Test.
        </Typography>
        <Button onClick={() => {this.props.changeRoute("/console/service_level/basic");}} className={classes.button} raised color="primary">
          Basic Service $50/month
        </Button>
        <Button disabled onClick={() => {this.props.changeRoute("/console/service_level/premium");}} className={classes.button} raised color="primary">
          Premium Service $200/month
        </Button>
        <Button disabled onClick={() => {this.props.changeRoute("/console/service_level/concierge");}} className={classes.button} raised color="primary">
          Concierge Service $500/month
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Start)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/ServiceLevel/scenes/Start/index.js